import type { KotsQuery, OrdersQuery } from './types/dine.types';

/*
 * TanStack Query keys. Prefixes are what the header refresh and the mutation
 * hooks invalidate: ['tables'], ['orders'], ['kots'].
 */
export const queryKeys = {
  outlet: () => ['outlet'] as const,
  /** The card; read for an order, it carries that order's prices. Both sit under the ['card'] prefix. */
  card: (orderId?: string) => (orderId ? (['card', orderId] as const) : (['card'] as const)),
  tables: () => ['tables'] as const,
  orders: (q: OrdersQuery = {}) => ['orders', 'list', q] as const,
  order: (id: string) => ['orders', 'detail', id] as const,
  kots: (q: KotsQuery = {}) => ['kots', 'list', q] as const,
  kot: (id: string) => ['kots', 'detail', id] as const,
  /** Open items and returned dishes waiting for a captain (return dish); under ['orders'] so the header refresh catches it. */
  approvals: () => ['orders', 'approvals'] as const,
  /** Requisitions awaiting this sign-in's approval (S3b); under ['orders'] for the same refresh. */
  requisitionApprovals: () => ['orders', 'requisition-approvals'] as const,
  inHouse: () => ['guests', 'in-house'] as const,
  buffetToday: () => ['buffet', 'today'] as const,
  buffetBoard: (meal: string) => ['buffet', 'board', meal] as const,
};

/** Query key prefix refreshed by the header button on each route. */
export function refreshKeyForPath(pathname: string): readonly string[] | null {
  if (pathname.startsWith('/tables')) return ['tables'];
  if (pathname.startsWith('/orders')) return ['orders'];
  if (pathname.startsWith('/kitchen')) return ['kots'];
  if (pathname.startsWith('/more')) return ['orders'];
  if (pathname.startsWith('/buffet')) return ['buffet'];
  return null;
}
